<svg
	fill="currentColor"
	version="1.1"
	id="Capa_1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	width="30px"
	height="30px"
	viewBox="0 0 475.695 475.696"
	xml:space="preserve"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<g>
			<polygon
				points="473.006,155.496 421.754,102.028 444.061,87.801 445.363,76.713 435.016,76.096 408.182,95.397 374.697,95.426 354.199,82.91 346.857,84.409 346.965,92.546 360.178,107.18 358.436,114.867 202.938,131.59 41.869,127.092 24.512,134.368 11.727,150.614 5.149,188.614 3.987,215.93 0,241.437 1.096,266.842 5.58,267.759 12.098,260.583 17.397,236.746 13.102,203.678 14.596,203.453 24.692,253.795 17.815,297.485 24.094,384.681 24.692,394.337 30.811,399.557 57.866,399.599 66.584,396.962 42.379,357.545 54.387,307.489 60.676,307.5 82.619,374.053 93.93,391.139 99.51,394.574 129.375,394.596 133.207,389.801 107.354,373.92 89.825,319.936 94.219,311.172 104.516,312.128 110.981,327.958 120.346,312.528 129.42,328.024 137.106,311.198 159.729,293.808 240.008,286.12 253.482,302.593 264.838,383.123 270.812,394.694 298.166,394.683 301.115,390.347 284.489,367.206 282.491,323.141 291.469,328.124 300.926,357.395 312.953,395.403 318.346,399.584 342.82,399.599 344.852,394.072 337.697,387.45 314.619,342.349 319.939,295.083 345.799,275.954 383.469,205.985 426.826,185.969 466.697,181.43 470.115,177.724 475.695,161.998 "
			/>
		</g>
	</g>
</svg>
